import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from '@reach/router';
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import {
  HOME,
  GET_DEMO,
  TRY_RISK_FREE,
} from '../constants/Paths';
import { HEADER_HIGHT } from '../styles/LayoutSetting';
import {
  OVERLAY_BLACK,
  BLACK,
  ORANGE,
  WHITE,
} from '../styles/Colors';
import { mobileDevice } from '../constants/DeviceBreakPoints';
import {
  Mobile,
  Default,
} from './MediaQueryComponent';

const useStyles = makeStyles(theme => ({
  navIcon: {
    backgroundColor: 'transparent',
    border: '0px',
    padding: 0,
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  navList: {
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(mobileDevice)]: {
      zIndex: 1,
      position: 'fixed',
      top: HEADER_HIGHT,
      left: 0,
      backgroundColor: OVERLAY_BLACK,
      width: '100%',
      padding: 10,
      flexDirection: 'column',
    },
  },
  navItem: {
    color: WHITE,
    textDecoration: 'none',
    margin: '0px 10px',
    '&:hover': {
      color: ORANGE,
      transform: 'scale(1.1)',
    },
    [theme.breakpoints.down(mobileDevice)]: {
      fontSize: 16,
      margin: 10,
    },
  },
  icon: {
    color: WHITE,
  },
  buttonLikeStyle: {
    color: BLACK,
    backgroundColor: ORANGE,
    borderRadius: 6,
    padding: '6px 10px',
    textAlign: 'center',
    '&:hover': {
      color: WHITE,
      transform: 'scale(1.1)',
    },
  },
  titleButton: {
    fontSize: 14,
  },
}));

const ListItem = ({
  labelText,
  path,
  onItemClick,
  listClassName = '',
}) => {
  const classes = useStyles();
  return (
    <Link
      className={`${classes.navItem} ${listClassName}`}
      to={path}
      onClick={onItemClick}
    >
      {labelText}
    </Link>
  );
};

ListItem.propTypes = {
  labelText: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  onItemClick: PropTypes.func,
  listClassName: PropTypes.string,
};

ListItem.defaultProps = {
  onItemClick: () => {},
  listClassName: '',
};

const NavMenuComponent = () => {
  const classes = useStyles();
  const [isNavVisible, setIsNavVisible] = useState(false);
  const toggleNavList = () => setIsNavVisible(!isNavVisible);
  const handleNavClosed = () => setIsNavVisible(false);
  const NavList = (
    <div className={classes.navList}>
      <ListItem
        labelText="Home"
        path={HOME}
        onItemClick={handleNavClosed}
      />
      <ListItem
        labelText="Get a Demo"
        path={GET_DEMO}
        onItemClick={handleNavClosed}
        listClassName={classes.buttonLikeStyle}
      />
      <ListItem
        labelText="Try Risk-Free"
        path={TRY_RISK_FREE}
        onItemClick={handleNavClosed}
        listClassName={classes.buttonLikeStyle}
      />
    </div>
  );

  return (
    <React.Fragment>
      <Mobile>
        <div className={classes.rowContainer}>
          <ListItem
            labelText="Try Risk-Free"
            path={TRY_RISK_FREE}
            onItemClick={handleNavClosed}
            listClassName={`${classes.buttonLikeStyle} ${classes.titleButton}`}
          />
          <button
            className={classes.navIcon}
            type="button"
            onClick={toggleNavList}
          >
            <MenuOutlinedIcon className={classes.icon} />
          </button>
        </div>
        {isNavVisible && NavList}
      </Mobile>
      <Default>
        {NavList}
      </Default>
    </React.Fragment>
  );
};

NavMenuComponent.propTypes = {};

NavMenuComponent.defaultProps = {};

export default NavMenuComponent;
